import React from 'react';
import type { Brand } from '../types/portal';
interface BrandLogoProps {
  brand: Brand;
  tone?: 'dark' | 'light';
  size?: 'md' | 'lg';
}
export function BrandLogo({
  brand,
  tone = 'dark',
  size = 'md'
}: BrandLogoProps) {
  const color = tone === 'light' ? 'text-white' : 'text-brand';
  const lg = size === 'lg';
  return <span aria-label={brand.name} className={`inline-flex flex-col items-stretch leading-none ${color}`} data-id="element-88" data-mp="1l1fhra5t06o6">
      <span className={`font-display font-medium tracking-[0.02em] ${lg ? 'text-5xl' : 'text-[28px]'}`} data-id="element-89" data-mp="1ys1273awooo6">NMHL</span>
      <span aria-hidden="true" className={`whitespace-nowrap font-sans font-semibold ${lg ? 'mt-1.5 text-[8.5px] tracking-[0.08em]' : 'mt-1 text-[5px] tracking-[0.06em]'}`} data-id="element-90" data-mp="1urqzq0mboge2">
        NATIONAL MORTGAGE HOME LOANS
      </span>
    </span>;
}